import { Component, Input, OnInit, TemplateRef, ViewChild, Inject, OnDestroy, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { IFundraiser } from '../../../../fundraiser/models/fundraiser.model';
import { ICurrency } from '../../../../shared/models';
import { IPaymentParam } from '../../../../shared/models/payment-params.model';
import { PaymentService, UtilService, StorageService, VwoService, VariablesService, PaymentV2Service } from '../../../../shared/services';
import { IContribute } from '../../models/contribute.model';
import { DEFAULT_CONFIG, FUNDRAISER_CONFIG, IPageConfig, STORY_CONFIG } from '../../objects/page.config';
import { PaymentUtilService } from '../../services';
import { Subscription } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { OptionsNavComponent } from '../options-nav/options-nav.component';
import { IPaymentConfig, PAYMENT_DEFAULT_CONFIG } from '../../models/payment.model';
@Component({
  selector: 'app-main-payment',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit, OnDestroy {

  @Input() fundraiser: IFundraiser;
  @Input() origin;
  @Input() event;
  @Input() internal;
  @Input() showBeneficiary;
  @Input() type;
  @Input() isBtnClicked;
  @Input() isRewardSelected = false;
  @Input() isQR;
  @Input() fixedAmount;
  @Input() onlyCurrency;
  @Input() eventCause;
  @Input() peopleServed;
  @Input() isStandAlone;
  @Input() upiMode;
  @Input() updateId;
  @Input() onpage;
  @Input() skipFailedCase;
  @Input() captchaType = 'dialog';
  @Input() paymentIcons;
  @Input() recommendTag;
  @Input() customTheme = '';
  @Input() skipMobileCheck;
  @Input() paymentHeader = true;
  @Input() sipCause;
  @Input() isSipStory;
  @Input() inputFields;
  @Input() headerType = 'v1';
  @Input() position;
  @Input() payment_config: IPaymentConfig;
  @Input() tagLabel;
  @Input() theme;
  @Input() tiptyp;
  config: IPageConfig;
  params = {} as IPaymentParam;
  @Input() contributeDetails: IContribute;
  isMobile: any;
  currency;
  @Input() screenName;
  subscriptions: Subscription[] = [];
  isCurrencyLoading;
  closeDialog;
  urlParams: IPaymentParam;
  userdata;
  @Output() moduleLoaded = new EventEmitter();

  @ViewChild('storyPaymentRef', { static: true }) public storyPaymentRef: TemplateRef<any>;
  @ViewChild('fullPayment', { static: true }) public fullPayment: TemplateRef<any>;
  @ViewChild(OptionsNavComponent) public optionsNav: OptionsNavComponent;
  previousCurrency;
  paymentCur;
  isStoryLink = false;
  cartData;
  contributeCalled = false;

  constructor(
    private actRoute: ActivatedRoute,
    private router: Router,
    private paymentUtilService: PaymentUtilService,
    private paymentService: PaymentService,
    public util: UtilService,
    public dialog: MatDialog,
    public storageService: StorageService,
    public vwo: VwoService,
    public vars: VariablesService,
    @Inject(DOCUMENT) public document: any,
    public paymentV2: PaymentV2Service
  ) {
    this.actRoute.queryParams.subscribe((param: IPaymentParam) => {
      this.urlParams = param;
      this.params.payment = param.payment;
      this.params.oi = param.oi;
      // sl for story link
      this.isStoryLink = param.sl === 'true' ? true : false;
      if (!param['payment'] && this.closeDialog) {
        this.dialog.closeAll();
        this.closeDialog = false;
      }
    });
  }

  async ngOnInit() {
    await this.util.cleanDuplicateUTMs(this.urlParams);  
    this.isMobile = this.util.isMobile();
    this.moduleLoaded.next(true);
    this.setConfig();
    this.getDetails();
    this.getConfig();
    this.subscriptions.push(this.vars.userData.subscribe(res => this.userdata = res));
    this.subscriptions.push(this.paymentUtilService.paymentCurrency.subscribe({ next: (res) => this.paymentCur = res }));
    this.subscriptions.push(this.vars.sipActiveOnPayment.subscribe({ next: (res) => setTimeout(() => this.params.or = res, 0) }));
    this.previousCurrency = this.storageService.getFromSession('currency');
    this.subscriptions.push(this.paymentUtilService.isSubmitted.subscribe({
      next: (res) => {
        if (res && this.vars.showKCart && !this.util.isMobile() && this.vars.pageName.match('stories|mini_story') && !this.urlParams?.utm_source?.match('internal_stories_otd_calling')) {
          return;
        }
        if (res && !this.isQR) {
          this.isSubmited(res);
        }
      }
    }));
    this.paymentUtilService.cartResponse.subscribe({
      next: resp => {
        this.cartData = resp;
      }
    });
  }

  setConfig() {
    // Set default config
    this.payment_config = { ...PAYMENT_DEFAULT_CONFIG, ...this.payment_config };
    this.subscriptions.push(this.paymentUtilService.paymentConfig.subscribe((c) => {
      if (c) {
        this.payment_config = { ...this.payment_config, ...c };
        if ((c?.is_sip === true && this.payment_config.sip_contribute_details) || (this.payment_config?.is_sip === true && c?.sip_contribute_details)) {
          this.getSipContribute();
        } else if (c?.is_sip === false) {
          this.getDetails();
        }
      }
    }));
  }

  /**Get the details for payment
   * it can be provide via input or url
   */
  getDetails() {
    if (this.internal) {
      this.params.id = this.fundraiser.id;
      this.params.or = this.origin,
        this.params.ct = this.fundraiser.custom_tag;
    } else {
      this.actRoute.queryParams.subscribe((param: IPaymentParam) => {
        this.params = {
          id: param.id,
          or: param.or,
          ct: param.ct,
          payment: param.payment,
          type: param.type
        };
        this.type = this.params['type'] || this.type;
      });
    }
    this.subscriptions.push(
      this.util.currency.subscribe({
        next: (res) => {
          if (this.contributeCalled && this.currency === res) return;
          this.contributeCalled = true;
          this.currency = res;
          // this.params.id = this.actRoute.snapshot.queryParams['id'];
          if (this.params.id && res) {
            if (this.util.isBrowser) {
              if (this.actRoute.snapshot.queryParams['selected_currency']) {
                this.getContributeFormDetails(this.actRoute.snapshot.queryParams['selected_currency']);
              } else if (this.origin !== 'tip') {
                const cartData = this.storageService.getFromSession('cartData');
                this.getContributeFormDetails(this.vars.showKCart && this.urlParams?.st !== 'f' ? this.currency : (cartData?.currency || this.currency));
              }
            }
          }
        }
      })
    );
  }
  /**Get the config of the page
   * so that the content can be switched to dynamically
   * for different pages
   */
  getConfig() {
    if (this.params.or === 's' || this.params.or === 'tann') {
      this.config = STORY_CONFIG;
      if (this.vars.showKCart && !this.isMobile) {
        this.config.mostDonors = true;
      }
    } else if (this.params.or === 'f' || this.params.or === 'up') {
      this.config = FUNDRAISER_CONFIG;
      if (this.vars.showStoryOnFundraiser) {
        this.config.mostDonors = false;
      }
    } else {
      this.config = DEFAULT_CONFIG;
    }
  }
  /**Navigate to the forms */
  navigateToForms(params) {
    this.router.navigate([], {
      queryParams: params,
      queryParamsHandling: 'merge'
    });
  }

  /**Get the query params for contribute api */
  getContibuteParams(data) {

    // no_pan_change to not change ask pan or passport on the basis of currency.
    // tslint:disable-next-line: no-bitwise
    let qParam = `?currency=${data.currency}&no_pan_change=true&update_multiplier=${true}&origin=${this.origin}&device=${this.vars.deviceType}`;
    if (this.sipCause) {
      qParam = qParam.concat(`&sip_cause=${this.sipCause}`);
    }
    if (this.isQR) {
      qParam = qParam.concat('&currency_only=INR');
    }
    if (this.onlyCurrency) {
      qParam = qParam.concat(`&currency_only=${this.onlyCurrency}`);
    }
    if (this.previousCurrency) {
      qParam = qParam.concat(`&pcurrency=${this.previousCurrency}`);
    }
    const utms = this.util.getUTMonly('url_string');
    if (utms) {
      qParam = qParam.concat(`&${utms}`);
    }
    if (this.router.url.match('stories')) {
      qParam = qParam.concat(`&is_story=true`);
    }
    if (data.currency === 'INR' && this.origin === 's' && !this.actRoute.snapshot.queryParams['mini_story']) {
      if (this.urlParams?.utm_campaign?.toLowerCase().match('lo|bd')) {
        qParam = qParam.concat(`&min_donation=99`);
      }
    }

    if (this.vwo.slab_AB()) {
      qParam = qParam.concat(`&slab_ab=${this.vwo.slab_AB()}`);
    }
    if (this.urlParams?.birthdaytime === '1') {
      qParam = qParam.concat(`&birthdaytime=1`);
    }
    if (this.isSipStory) {
      qParam = qParam.concat(`&sip_story=1`);
    }
    return qParam;
  }

  /**Get the currency when user change it from header */
  getCurrencyFromHeader(data: ICurrency) {
    this.isCurrencyLoading = true;
    if (this.payment_config?.is_sip) {
      this.paymentUtilService.paymentConfig.next({ currency: data?.currency || 'INR' });
      return;
    }
    const qParam = this.getContibuteParams(data);
    this.paymentService.getContributeDetails(this.params.id, qParam).subscribe(async (res: any) => {
      res.data.data = await this.setSlabs(res.data.data);
      this.contributeDetails = res.data.data;
      if (!this.contributeDetails?.insurance) {
        this.vars.selectedFamilyInsurance = null;
      }
      this.setAnniversaryAmount();
      this.paymentUtilService.paymentCurrency.next(this.contributeDetails.selected_currency);
      this.paymentUtilService.supportedCurrencies.next(this.contributeDetails.supported_currency);
      this.isCurrencyLoading = false;
    });
  }

  /**Check the lenth of the reward */
  checkReward() {
    return this.contributeDetails && this.contributeDetails.rewards && this.contributeDetails.rewards.length
      && !this.isRewardSelected && !this.fixedAmount;
  }
  /**Is amount form submited */
  isSubmited(data) {
    if (!this.isMobile || this.onpage || (this.isMobile && !this.vars.pageName.match('stories|mini_story'))) {
      this.screenName = 'options';
    }
    if (this.dialog.getDialogById('otdPaymentDialog')) { return; }
    let template;
    if (this.origin === 's') {
      template = this.isMobile ? this.fullPayment : this.storyPaymentRef;
    } else {
      template = this.fullPayment;
    }
    // is sl story link true
    if (!this.isStoryLink) {
      setTimeout(() => {
        if (typeof document !== 'undefined') {
          this.document.body.style.overflowY = 'hidden';
        }
        this.dialog.closeAll();
        const tempParams = {
          id: 'otdPaymentDialog',
          width: '100vw',
          maxWidth: '660px',
          minHeight: '550px',
          height: 'auto',
          maxHeight: 'calc(100vh - 50px)',
          panelClass: 'payment-dialog',
          disableClose: true,
          closeOnNavigation: false
        };
        if (this.util.isMobile()) {
          tempParams['height'] = '100vh';
          tempParams['maxHeight'] = 'auto';
        }
        this.dialog.open(template, tempParams).afterClosed().subscribe(() => {
          if (typeof document !== 'undefined') {
            this.document.body.style.overflowY = 'auto';
          }
          this.navigateToForms({ modal: null, op: null });
        });
      }, 0);
    }
  }

  setAnniversaryAmount() {
    if (this.router.url.includes('anniversary') && !this.urlParams['enable_sip']) {
      this.contributeDetails.min_donation = 10;
      this.contributeDetails.default_amount = 10;
      this.contributeDetails.slabs[0] = 10;
    }
  }

  /**Get the details of the payment
   * like forms configurations, rewards and supported currencies
   */
  getContributeFormDetails(currency) {
    const qParam = this.getContibuteParams({ currency: currency });
    this.paymentService.getContributeDetails(this.params.id, qParam).subscribe(async (res: any) => {

      res.data.data = await this.setSlabs(res.data.data);

      this.contributeDetails = { ...res.data.data };
      this.paymentUtilService.sendDonationSlabEvent(this.contributeDetails);

      // Ketto Anniversary special amount
      this.setAnniversaryAmount();
      // re-initializing supported currencies on payment observable side.
      this.paymentUtilService.supportedCurrencies.next(res.data.data.supported_currency);
      if (this.upiMode) {
        this.contributeDetails.min_donation = this.origin === 's' ? 99 : 1;
      }
      if (this.isQR) {
        this.contributeDetails.min_donation = this.origin === 's' ? 99 : 1
      }
      // on upi mode supported currencies will only be INR as upi is supported only in india
      // on non upi mode supported currencies will have all currencies

      const supportedCurrencies = this.upiMode && this.upiMode.mode.match('UPI|WALLET') ? ['INR'] :
        this.contributeDetails.supported_currency;

      // changing contrib detail object and pushing it on supported currencies observable
      this.contributeDetails.supported_currency = [...supportedCurrencies];
      this.paymentUtilService.supportedCurrencies.next(supportedCurrencies);


      this.paymentUtilService.paymentCurrency.next(this.contributeDetails.selected_currency);
      this.closeDialog = true;
      if (this.checkReward() && !this.fixedAmount) {
        this.navigateToForms({ payment: 'rd' });
        this.screenName = 'rd';
      } else {
        const cartData = this.util.storage.getFromSession('cartData');
        if (this.actRoute.snapshot.queryParams['st'] === 'f' && cartData) {
          if (this.isBtnClicked && !(this.vars.showKCart && !this.util.isMobile() && this.vars.pageName.match('stories|mini_story'))) {
            this.navigateToForms({ payment: 'form' });
            this.screenName = 'form';
          }
        } else {
          this.navigateToForms({ payment: this.screenName || 'form' });
          if (!this.screenName) {
            this.screenName = 'form';
          }
        }
      }
    });
  }

  setSlabs(data) {
    return new Promise((resolve) => {
      // const utmSource: string = this.urlParams?.utm_source || '';
      // if (data?.selected_currency === 'INR' && !this.userdata) {
      //   let newINRSlabs = [];
      //   if (this.fundraiser?.parent_cause_id !== 149 && this.fundraiser?.parent_cause_id !== 48 && (/^(medical)$/i).test(this.fundraiser?.cause?.info_1) && this.isMobile) {
      //     newINRSlabs = [300, 700, 2500];
      //   } else if (this.fundraiser?.parent_cause_id !== 149 && this.fundraiser?.parent_cause_id !== 48) {
      //     newINRSlabs = [300, 1000, 3000];
      //   } else if (this.fundraiser?.parent_cause_id === 48 && utmSource.match('internal|google')) {
      //     newINRSlabs = [300, 700, 1500];
      //   } else if (this.fundraiser?.parent_cause_id === 48 && (!utmSource || utmSource.match('External|external')) && !(/^(external_impact_calling)$/i).test(utmSource)) {
      //     newINRSlabs = [300, 1000, 2000];
      //   } else if (this.fundraiser?.parent_cause_id === 149 && utmSource.match('External|external') && !(/^(external_ct|external_telecalling|external_impact_calling)$/i).test(utmSource)) {
      //     newINRSlabs = [350, 500, 1200];
      //   } else if (this.fundraiser?.parent_cause_id === 149 && (!utmSource.match('External|external') || (/^(external_ct|external_telecalling|external_impact_calling)$/i).test(utmSource))) {
      //     newINRSlabs = [380, 900, 1500];
      //   }
      //   if (newINRSlabs.length > 1) {
      //     data.slabs = newINRSlabs;
      //     data.default_amount = newINRSlabs[1];
      //   }
      // }
      resolve(data);
    });
  }

  getSipContribute() {
    this.contributeDetails = this.payment_config?.sip_contribute_details;
    this.params.id = this.payment_config?.sip_contribute_details?.campaign?.id;
    this.paymentUtilService.paymentCurrency.next(this.payment_config?.currency);
    this.paymentUtilService.supportedCurrencies.next(this.payment_config?.sip_contribute_details?.supported_currency);
    this.isCurrencyLoading = false;
  }

  ngOnDestroy(): void {
    // Called once, before the instance is destroyed.
    // Add 'implements OnDestroy' to the class.
    this.paymentUtilService.isSubmitted.next(false);
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
